// Domain Configurations Index
// This file exports all individual domain configurations

import { geotabCameraConfig } from './geotab-camera.js';
import { geotabgofocusplusConfig } from './geotabgofocusplus.js';
import { geotabDashcamsConfig } from './geotab-dashcams.js';
import { geotabDashcamConfig } from './geotab-dashcam.js';
import { geotabstoreConfig } from './geotabstore.js';
import { geotabpartnerConfig } from './geotabpartner.js';
import { geotabequipmentConfig } from './geotab-equipment.js';
import { gogeotabConfig } from './gogeotab.js';
import { geotabKeyConfig } from './geotab-key.js';
import { geotabkeylessConfig } from './geotab-keyless.js';
import { fleetKeylessConfig } from './fleet-keyless.js';
import { keylessfleetConfig } from './keyless-fleet.js';
import { fleethoursofserviceConfig } from './fleet-hours-of-service.js';
import { eldsystemConfig } from './eldsystem.js';
import { eldtrackerConfig } from './eldtracker.js';
import { fleetdashcamConfig } from './fleet-dashcam.js';
import { goinsightsConfig } from './go-insights.js';
import { fleetflixConfig } from './fleet-flix.js';
import { smarterTrackingConfig } from './smarter-tracking.js';
import { roadEazyConfig } from './road-eazy.js';
import { surfsightCamConfig } from './surfsight-cam.js';
import { lytxstoreConfig } from './lytxstore.js';
import { shopgeotabConfig } from './shopgeotab.js';
import { shopsurfsightConfig } from './shopsurfsight.js';
import { lytxCameraConfig } from './lytx-camera.js';

// Domain mapping - maps hostnames to domain IDs (each domain has its own separate config)
export const DOMAIN_MAPPING = {
  // Geotab Cameras Domains
  'geotabcamera.com': 'geotab-camera',
  'geotab.cam': 'geotab-camera',
  'geotabdashcams.com': 'geotab-dashcams',
  'geotabdashcam.com': 'geotab-dashcam',
  'geotabgofocusplus.com': 'geotabgofocusplus',
  
  // Geotab Equipment Domains
  'geotabequipment.com': 'geotab-equipment',
  'geotab.ai': 'geotabpartner',

  'geotabpartner.com': 'geotabpartner',
  'gogeotab.com': 'gogeotab',
  'geotabgo.com': 'gogeotab',
  
  // Geotab Store Domains
  'geotabstore.com': 'geotabstore',
  'geotab.store': 'geotabstore',
  'shopgeotab.com': 'shopgeotab',

  // Geotab Key Domains
  'fleetkeyless.com': 'fleet-keyless',
  'geotabkey.com': 'geotab-key',
  'geotabkeyless.com': 'geotab-keyless',
  'keylessfleet.com': 'keyless-fleet',
  'myfleetkey.com': 'geotab-key',
  
  // Road Eazy Domains
  'roadeazy.cam': 'road-eazy',
  'shoproadeazy.com': 'road-eazy',
  'buyroadeazy.com': 'road-eazy',
  'roadeazycamera.com': 'road-eazy',
  
  // Surfsight Camera Domains
  'lytx.camera': 'lytx-camera',
  
  'surfsight.cam': 'surfsight-cam',
  'surfsight.camera': 'surfsight-cam',
  
  // Shop Surfsight Camera Domains
  'lytxstore.com': 'lytxstore',
  'shoplytx.com': 'lytxstore',

  'shopsurfsight.com': 'shopsurfsight',
  'surfsight.shop': 'shopsurfsight',
  'surfsightstore.com': 'shopsurfsight',

  // Fleet Domains
  'fleethoursofservice.com': 'fleet-hours-of-service',
  'eldsystem.com': 'eldsystem',
  'eldtracker.com': 'eldtracker',

  // Fleet Dashcam Domains
  'fleetdashcam.com': 'fleet-dashcam',

  // Fleet Flix Domains
  'fleetflix.com': 'fleet-flix',

  // Other
  'smartertracking.com': 'smarter-tracking',
  'goinsights.com': 'go-insights',
  
  // WWW variants
  'www.geotabcamera.com': 'geotab-camera',
  'www.geotab.cam': 'geotab-camera',
  'www.geotabdashcams.com': 'geotab-dashcams',
  'www.geotabdashcam.com': 'geotab-dashcam',
  'www.geotabgofocusplus.com': 'geotabgofocusplus',

  'www.geotab.store': 'geotabstore',
  'www.geotabstore.com': 'geotabstore',
  'www.shopgeotab.com': 'shopgeotab',

  'www.geotabequipment.com': 'geotab-equipment',
  'www.geotab.ai': 'geotabpartner',
  'www.geotabgo.com': 'gogeotab',
  'www.geotabpartner.com': 'geotabpartner',
  'www.gogeotab.com': 'gogeotab',

  'www.fleetkeyless.com': 'fleet-keyless',
  'www.geotabkey.com': 'geotab-key',
  'www.geotabkeyless.com': 'geotab-keyless',
  'www.keylessfleet.com': 'keyless-fleet',
  'www.myfleetkey.com': 'geotab-key',

  'www.roadeazy.cam': 'road-eazy',
  'www.shoproadeazy.com': 'road-eazy',
  'www.buyroadeazy.com': 'road-eazy',
  'www.roadeazycamera.com': 'road-eazy',

  'www.fleethoursofservice.com': 'fleet-hours-of-service',
  'www.eldsystem.com': 'eldsystem',
  'www.eldtracker.com': 'eldtracker',

  'www.lytx.camera': 'lytx-camera',
  'www.surfsight.cam': 'surfsight-cam',
  'www.surfsight.camera': 'surfsight-cam',
  
  'www.lytxstore.com': 'lytxstore',
  'www.shoplytx.com': 'lytxstore',
  'www.shopsurfsight.com': 'shopsurfsight',
  'www.surfsight.shop': 'shopsurfsight',
  'www.surfsightstore.com': 'shopsurfsight',

  'www.fleetdashcam.com': 'fleet-dashcam',

  'www.fleetflix.com': 'fleet-flix',

  'www.smartertracking.com': 'smarter-tracking',
  'www.goinsights.com': 'go-insights',
};

// All domain configurations (each domain has its own separate config)
export const DOMAIN_CONFIGS = {
  // Geotab Domains
  'geotab-camera': geotabCameraConfig,
  'geotabgofocusplus': geotabgofocusplusConfig,
  'geotab-dashcams': geotabDashcamsConfig,
  'geotab-dashcam': geotabDashcamConfig,
  'geotabstore': geotabstoreConfig,
  'geotabpartner': geotabpartnerConfig,
  'geotab-equipment': geotabequipmentConfig,
  'gogeotab': gogeotabConfig,
  'geotab-key': geotabKeyConfig,
  'geotab-keyless': geotabkeylessConfig,
  
  // Fleet Domains
  'fleet-keyless': fleetKeylessConfig,
  'keyless-fleet': keylessfleetConfig,
  'fleet-hours-of-service': fleethoursofserviceConfig,
  'eldsystem': eldsystemConfig,
  'eldtracker': eldtrackerConfig,
  'fleet-dashcam': fleetdashcamConfig,
  
  // Other Domains
  'smarter-tracking': smarterTrackingConfig,
  'road-eazy': roadEazyConfig,
  'go-insights': goinsightsConfig,
  'fleet-flix': fleetflixConfig,

  // Surfsight Camera Domains
  'surfsight-cam': surfsightCamConfig,
  'lytxstore': lytxstoreConfig,
  'shopgeotab': shopgeotabConfig,
  'shopsurfsight': shopsurfsightConfig,
  'lytx-camera': lytxCameraConfig,
};

// Helper function to get domain config by hostname
export const getDomainConfigByHostname = (hostname) => {
  const cleanHostname = hostname.replace(/^www\./, '').toLowerCase();
  const domainId = DOMAIN_MAPPING[cleanHostname] || DOMAIN_MAPPING[`www.${cleanHostname}`];
  
  if (domainId && DOMAIN_CONFIGS[domainId]) {
    return DOMAIN_CONFIGS[domainId];
  }
  
  // Return default config if no match found
  return DOMAIN_CONFIGS['fleet-dashcam'];
};

// Helper function to get domain config by ID
export const getDomainConfigById = (id) => {
  return DOMAIN_CONFIGS[id] || null;
};

// Helper function to get all available domain IDs
export const getAllDomainIds = () => {
  return Object.keys(DOMAIN_CONFIGS);
};

// Helper function to get all available hostnames
export const getAllHostnames = () => {
  return Object.keys(DOMAIN_MAPPING);
};

// Export individual configs for direct access
export {
  geotabCameraConfig,
  geotabDashcamsConfig,
  geotabDashcamConfig,
  geotabgofocusplusConfig,
  geotabstoreConfig,
  geotabequipmentConfig,
  gogeotabConfig,
  geotabpartnerConfig,
  shopgeotabConfig,
  fleetKeylessConfig,
  geotabKeyConfig,
  geotabkeylessConfig,
  keylessfleetConfig,
  roadEazyConfig,
  lytxCameraConfig,
  surfsightCamConfig,
  lytxstoreConfig,
  shopsurfsightConfig,
  eldsystemConfig,
  eldtrackerConfig,
  fleethoursofserviceConfig,
  fleetdashcamConfig,
  fleetflixConfig,
  goinsightsConfig,
  smarterTrackingConfig,
};
